function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.1,54.56A182.21,182.21,0,0,1,48.76,34.71c38.18-23,81.42-38.17,126.48-34C194,2.4,214,5.78,230.72,14.94c15.78,8.64,22.57,21.93,24.45,39.34,2.63,24.41-21.07,21.39-37.49,27.54-12,4.49-12.62,11.48-17.47,21.44-9,18.47-25.29,31.05-45,36.41-18.09,4.92-41.41,10.43-57.94-1.4A115.21,115.21,0,0,0,49,117.91c-11.43-1.94-22.58-2.27-33.13-7.57C-13,95.82,2.66,72.18,22.1,54.56Z"
}));

function SvgBackgroundW1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.37 145.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundW1);
export default __webpack_public_path__ + "static/media/background-w-1.49b97e5d.svg";
export { ForwardRef as ReactComponent };